// Globals
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DragEndEvent } from '@dnd-kit/core';

// Components
import { DraggableTable } from '@/components';
import { Table } from '@/ui';
import { StyledContentBlock, StyledPageWrapper } from '../Styled';
import { BannersFiltersContainer } from '../../containers';
import { getBannersTableColumns } from './columns';

// Models
import { IBanner } from '@/models/banners.model';

type TBannersList = {
  bannersList: IBanner[];
  isLoading: boolean;
  setBannerForDelete: (banner: IBanner) => void;
  handleEditClick: (banner: IBanner) => void;
  handleDragEnd: (event: DragEndEvent) => Promise<void>;
  canManage: boolean;
};

const BannersList = ({
  bannersList,
  isLoading,
  handleDragEnd,
  setBannerForDelete,
  handleEditClick,
  canManage,
}: TBannersList) => {
  const { t } = useTranslation(['banners']);

  const columns = getBannersTableColumns({ t, handleEditClick, setBannerForDelete, canManage });
  const components = {
    header: {
      wrapper: BannersFiltersContainer,
    },
  };

  return (
    <StyledPageWrapper>
      <StyledContentBlock>
        {canManage ? (
          <DraggableTable
            columns={columns}
            dataSource={bannersList || []}
            rowKey="id"
            loading={isLoading}
            onDragEnd={handleDragEnd}
            components={components}
          />
        ) : (
          <Table
            columns={columns}
            dataSource={bannersList || []}
            rowKey="id"
            loading={isLoading}
            components={components}
          />
        )}
      </StyledContentBlock>
    </StyledPageWrapper>
  );
};

export default BannersList;
